"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".donut-parent[_ngcontent-%COMP%]{margin-top:-50px;min-height:350px;min-width:350px}"];
exports.styles = styles;
